






import { defineComponent, onMounted } from '@vue/composition-api'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'ScrollTop',
  setup () {
    onMounted(() => {
      window.scrollTo(0, 0)
    })
  }
})
